import React from 'react';
import './App.css';

function App() {
  return (
    <div className="app">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="nav">
            <div className="logo">
              <h1>Stradago</h1>
            </div>
            <nav className="nav-links">
              <a href="#trips">Trips</a>
              <a href="#about">About</a>
              <a href="#contact">Contact</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Exclusive Group Travel</h1>
            <p>Premium travel booking for Boy Scouts, Girl Scouts, 4H clubs, traveling sports teams, church groups, and mission trips. Curated experiences designed for organized groups.</p>
            <div className="cta-buttons">
              <a href="#contact" className="btn-primary">Plan Your Trip</a>
              <a href="#trips" className="btn-secondary">View Adventures</a>
            </div>
          </div>
        </div>
      </section>

      {/* Trips Section */}
      <section id="trips" className="services">
        <div className="container">
          <h2>Exclusive Group Experiences</h2>
          <div className="services-grid">
            <div className="service-card">
              <h3>Scouting Adventures</h3>
              <p>Premium Boy Scout & Girl Scout expeditions with exclusive access to national parks, high adventure bases, and specialized merit badge programs.</p>
            </div>
            <div className="service-card">
              <h3>Sports Team Travel</h3>
              <p>Elite accommodations and travel packages for traveling sports clubs, tournaments, and championship events with VIP treatment.</p>
            </div>
            <div className="service-card">
              <h3>Church & Mission Groups</h3>
              <p>Carefully curated mission trips, church retreats, and spiritual journeys to meaningful destinations worldwide.</p>
            </div>
            <div className="service-card">
              <h3>4H & Educational Groups</h3>
              <p>Immersive educational travel experiences, agricultural tours, and hands-on learning adventures for 4H clubs and schools.</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>About Stradago</h2>
              <p>Stradago is an exclusive travel booking platform designed specifically for organized groups. We provide premium access to destinations, accommodations, and experiences that regular travel sites can't offer.</p>
              <p>Our curated network of partners ensures your group receives VIP treatment, exclusive pricing, and customized itineraries tailored to your organization's unique needs and goals.</p>
            </div>
            <div className="about-stats">
              <div className="stat">
                <h3>2,500+</h3>
                <p>Groups Served</p>
              </div>
              <div className="stat">
                <h3>50+</h3>
                <p>Destinations</p>
              </div>
              <div className="stat">
                <h3>VIP</h3>
                <p>Access Only</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <h2>Request Exclusive Access</h2>
          <div className="contact-content">
            <div className="contact-info">
              <h3>Ready for VIP Group Travel?</h3>
              <p>Join our exclusive network and unlock premium travel experiences, group discounts, and VIP treatment for your organization.</p>
              <div className="contact-details">
                <p><strong>Email:</strong> concierge@stradago.com</p>
              </div>
            </div>
            <form className="contact-form">
              <input type="text" placeholder="Group Leader/Organizer Name" required />
              <input type="email" placeholder="Email Address" required />
              <input type="text" placeholder="Organization Name" />
              <select required>
                <option value="">Select Organization Type</option>
                <option value="boy-scouts">Boy Scouts</option>
                <option value="girl-scouts">Girl Scouts</option>
                <option value="4h">4H Club</option>
                <option value="sports-team">Traveling Sports Team</option>
                <option value="church">Church Group</option>
                <option value="mission">Mission Trip</option>
                <option value="school">School/Educational</option>
                <option value="other">Other</option>
              </select>
              <textarea placeholder="Tell us about your group size, travel dates, destination preferences, and budget range..." rows="5" required></textarea>
              <button type="submit" className="btn-primary">Request VIP Access</button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h3>Stradago</h3>
              <p>Exclusive Group Travel Booking</p>
            </div>
            <div className="footer-links">
              <a href="#trips">Experiences</a>
              <a href="#about">About</a>
              <a href="#contact">Contact</a>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Stradago. Exclusive travel booking for organized groups nationwide.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;